export const NB_CONSULTANT_MOTIVATION_POPUP = 'newbuilding_consultant_motivation_popup';
export const NB_HELP_IN_SEARCH = 'newbuilding_consultant_help_in_search';
export const REFFECTION_EXPERIMENT = 'newbuilding_reffection';
export const NB_CONSULTANT_TRIGGERING_MESSAGE = 'newbuilding-triggering-message';

export const EXPERIMENTS: string[] = [
  NB_CONSULTANT_MOTIVATION_POPUP,
  NB_HELP_IN_SEARCH,
  REFFECTION_EXPERIMENT,
  NB_CONSULTANT_TRIGGERING_MESSAGE,
];
